import {
  LargeBorderButton,
  LargeSolidButton,
  largeModalButtonLabelClassName,
} from "@/components/ui/button/large-modal-buttons";

const FOOTER_ROW_CLASS =
  "relative mt-auto flex flex-shrink-0 justify-center gap-[20px] bg-background p-6 pb-10 pt-0 before:absolute before:-top-10 before:left-0 before:h-10 before:w-full before:bg-gradient-to-t before:from-background before:to-transparent before:content-['']";

export type NurseModalFooterButtonsProps = {
  onClose: () => void;
  onConfirm: () => void;
  closeLabel?: string;
  confirmLabel?: string;
  confirmDisabled?: boolean;
};

/** 간호사/근무자 관리 모달 하단 레이아웃 + LargeBorder / LargeSolid 조합 */
export default function NurseModalFooterButtons({
  onClose,
  onConfirm,
  closeLabel = "닫기",
  confirmLabel = "저장하기",
  confirmDisabled = false,
}: NurseModalFooterButtonsProps) {
  return (
    <div className={FOOTER_ROW_CLASS}>
      <LargeBorderButton onClick={onClose}>
        <span className={largeModalButtonLabelClassName}>{closeLabel}</span>
      </LargeBorderButton>
      <LargeSolidButton onClick={onConfirm} disabled={confirmDisabled}>
        <span className={largeModalButtonLabelClassName}>{confirmLabel}</span>
      </LargeSolidButton>
    </div>
  );
}
